import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const generateMonths = (count) => {
  const months = [
    'Week1', 'Week2', 'Week3', 'Week3', 'Week4', 
    'week5', 'Week6', 'week7', 'Week8', 'October', 
    'November', 'December'
  ];
  return months.slice(0, count);
};



const BarChart = () => {
  const labels = generateMonths(5);
  const data = {
    labels: labels,
    datasets: [
      {
        label: 'percentage',
        data: [65, 80, 90, 81, 56, 55, 40],
        backgroundColor: [
          '#234492',
          '#234492',
          '#234492',
          '#234492',
          '#234492',
          '#234492',
          '#234492'
        ],
        borderRadius: {
            topLeft: 10,
            topRight: 10,
            bottomLeft: 0,
            bottomRight: 0
          },
        borderColor: [
            '#234492',
            '#234492',
            '#234492',
            '#234492',
            '#234492',
            '#234492',
            '#234492'
        ],
        borderWidth: 1
      }
    ]
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top'
      },
      title: {
        display: true,
        text: ''
      }
    }
  };

  return <Bar data={data} options={options} />;
};

export default BarChart;
